import { loadLinksInteraction } from "./interaction";
import { loadLinksPlugin } from "./plugin";
export async function loadParticlesLinksInteraction(engine) {
  let refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  await loadLinksInteraction(engine, refresh);
  await loadLinksPlugin(engine, refresh);
}
export * from "./Options/Classes/Links";
export * from "./Options/Classes/LinksShadow";
export * from "./Options/Classes/LinksTriangle";
export * from "./Options/Interfaces/ILinks";
export * from "./Options/Interfaces/ILinksShadow";
export * from "./Options/Interfaces/ILinksTriangle";